import { c as _c } from "react/compiler-runtime";
import styles from './BlogMdxYouTube.module.scss';
import { parseYouTubeId } from '../model/blog-youtube';
type BlogMdxYouTubeProps = {
  url: string;
  title?: string;
};

// MDX 본문용 YouTube 임베드. mdx-components.tsx 에 전역 등록되어
// MDX 파일에서 import 없이 <YouTube url="..." /> 로 사용한다.
export function BlogMdxYouTube(t0) {
  const $ = _c(5);
  const {
    url,
    title: t1
  } = t0;
  const title = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== url) {
    t2 = parseYouTubeId(url);
    $[0] = url;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const youtubeId = t2;
  if (!youtubeId) {
    return null;
  }
  const t3 = `https://www.youtube-nocookie.com/embed/${youtubeId}`;
  let t4;
  if ($[2] !== t3 || $[3] !== title) {
    t4 = <div className={styles.embed}><iframe className={styles.iframe} src={t3} title={title} loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} referrerPolicy="strict-origin-when-cross-origin" /></div>;
    $[2] = t3;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}